const FILE_BASE = process.env.REACT_APP_SERVER_IP ?? "";

/** URL for a publication PDF, served from the API server's uploads folder. */
export const publicationPdfUrl = (filename: string): string =>
  `${FILE_BASE}/publications/pdf/${filename}`;

/** URL for a publication thumbnail, served from the API server's uploads folder. */
export const publicationThumbnailUrl = (filename: string): string =>
  `${FILE_BASE}/publications/thumbnails/${filename}`;
